import { AfterViewInit, Component, ViewChild, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { jqxButtonModule } from 'jqwidgets-ng/jqxbuttons';
import { jqxCheckBoxComponent, jqxCheckBoxModule } from 'jqwidgets-ng/jqxcheckbox';
import { jqxWindowComponent, jqxWindowModule } from 'jqwidgets-ng/jqxwindow';
import { AppComponent } from 'src/app/app.component';
import { environment } from 'src/environments/environment';
import { CustomForms } from '../../forms/custom-forms';
import { InstalacionService, InstallationTypes } from 'src/app/services/elements/instalacion/instalacion.service';
import { LoaderComponent } from 'movisat-common-gui';
@Component({
  selector: 'app-element-install-options',
  standalone: true,
  imports: [jqxButtonModule, jqxCheckBoxModule, jqxWindowModule, FormsModule, LoaderComponent],
  templateUrl: './element-install-options.component.html',
  styleUrl: './element-install-options.component.css'
})
export class ElementInstallOptionsComponent extends CustomForms implements AfterViewInit, OnDestroy {
  @ViewChild('opcionesWindow', { static: false }) opcionesWindow!: jqxWindowComponent;
  @ViewChild('checkTag', { static: false }) checkTag!: jqxCheckBoxComponent;
  @ViewChild('checkVolumetrico', { static: false }) checkVolumetrico!: jqxCheckBoxComponent;
  @ViewChild('checkCerraduraGeneral', { static: false }) checkCerraduraGeneral!: jqxCheckBoxComponent;
  @ViewChild('checkIdentificacion', { static: false }) checkIdentificacion!: jqxCheckBoxComponent;

  componentRef: any;
  elements = [];
  InstallationTypes = InstallationTypes;
  observaciones: string = '';
  isSaving = false;

  constructor(private instalacionService: InstalacionService) {
    super();
  }

  public init(componentRef: any, elements: any) {
    this.componentRef = componentRef;
    this.elements = elements;
  }

  opciones: Record<InstallationTypes, boolean> = {
    [InstallationTypes.TAG]: false,
    [InstallationTypes.VOLUMETRIC]: false,
    [InstallationTypes.LOCK]: false,
    [InstallationTypes.IDENTIFIER]: false,
  };

  public theme = environment.tema;

  ngAfterViewInit(): void {
    this.addCustomForm(this.opcionesWindow, false);
    if (this.elements.map((elem: any) => elem?.Instalacion?.requiereInstalacionIdentificador).includes(false)) {
      this.checkIdentificacion.disabled(true);
    }
  }

  cerrarOpciones() {
    this.opcionesWindow.close();
  }

  actualizarOpciones(idTipo: InstallationTypes | null) {
    if (idTipo !== null) {
      this.opciones[idTipo] = this.obtenerValorCheckBox(idTipo);
    } else {
      this.opciones = {
        [InstallationTypes.TAG]: this.obtenerValorCheckBox(InstallationTypes.TAG),
        [InstallationTypes.VOLUMETRIC]: this.obtenerValorCheckBox(InstallationTypes.VOLUMETRIC),
        [InstallationTypes.LOCK]: this.obtenerValorCheckBox(InstallationTypes.LOCK),
        [InstallationTypes.IDENTIFIER]: this.obtenerValorCheckBox(InstallationTypes.IDENTIFIER)
      };
    }

    if (!this.obtenerValorCheckBox(InstallationTypes.IDENTIFIER)) {
      this.checkCerraduraGeneral.checked(false);
    }

  }

  protected obtenerValorCheckBox(idTipo: InstallationTypes): boolean {
    switch (idTipo) {
      case InstallationTypes.TAG:
        return this.checkTag?.val() || false;
      case InstallationTypes.VOLUMETRIC:
        return this.checkVolumetrico?.val() || false;
      case InstallationTypes.LOCK:
        return this.checkCerraduraGeneral?.val() || false;
      case InstallationTypes.IDENTIFIER:
        return this.checkIdentificacion?.val() || false;
      default:
        return false;
    }
  }

  saveOptionsInstall() {
    this.isSaving = true;
    const instalacionesSeleccionadas: InstallationTypes[] = Object.entries(this.opciones)
      .filter(([, value]) => value)
      .map(([key]) => Number(key) as InstallationTypes);
  
    this.instalacionService.saveInstalacionList(this.elements, instalacionesSeleccionadas, this.observaciones)
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        this.isSaving = false;
        this.opcionesWindow.close();
      });
  }

  translate(text: string): string {
    return AppComponent.translate(text);
  }

  ngOnDestroy() {
    this.componentRef.destroy();
  }

}
